<template lang="pug">
.floor-plan-dot-prompt-content(
  @mousemove="mouseMoveOnPrompt()",
  :class="`dot-id-${dot.id}`",
  @mouseleave="hidePrompt()"
)
  .floor-plan-dot-prompt-content-wrapper(:style="{ maxHeight: `${maxHeight}px` }")
    .floor-plan-dot-prompt-content-item(v-for="(value, key) in shortInfo", :key="`${key} ${value}`")
      | {{ key }}
      p {{ getPromptValue(value) || "—" }}
</template>

<script setup>
import { ref, computed } from "vue";
import { parseISO, format } from "date-fns";

const props = defineProps({
  promptData: { type: Object, default: () => {} },
});

const emit = defineEmits("showPrompt", "hidePrompt");

const shortInfo = computed(() => props.promptData.dot.short_info);
const dot = computed(() => props.promptData.dot);
const floor_plan_id = computed(() => props.promptData.floor_plan_id);
const maxHeight = computed(() => props.promptData.maxHeight);

const isValidDate = date => {
  return date instanceof Date && !isNaN(date.getTime());
};

const getPromptValue = val => {
  const date = parseISO(val);
  if (isValidDate(date)) {
    return format(date, "dd.MM.yyyy");
  } else {
    return val;
  }
};

const showPrompt = () => {
  emit("showPrompt");
};

const hidePrompt = () => {
  emit("hidePrompt");
};

const mouseMoveOnPrompt = () => {
  const currentPrompt = event.target.closest(`.dot-id-${dot.value?.id}`);
  if (currentPrompt) {
    showPrompt();
  } else {
    hidePrompt();
  }
};
</script>

<style lang="scss">
@import "../../../../assets/styles/floor-plan/main";

.floor-plan-dot-prompt-content-wrapper {
  overflow-y: scroll;
}
</style>
